import Flex, { ALIGN_CLASS, DIRECTION_CLASS, GAP_CLASS } from "components/Flex";
import { arrayOf, number, shape, string } from "prop-types";
import React from "react";

import styles from "./OpportunityTooltipContent.module.scss";

const daysLabel = (n) => (n === 1 ? "1 day" : `${n} days`);

const OpportunityTooltipContent = ({ opportunity }) => {
  const {
    opportunityName,
    customerName,
    stageName,
    stageColor,
    daysInStage,
    assignees,
  } = opportunity;
  const hasAssignees = assignees.length > 0;

  return (
    <Flex
      direction={DIRECTION_CLASS.column}
      gap={GAP_CLASS.GAP_200}
      alignItems={ALIGN_CLASS.stretch}
      className={styles.opportunityTooltip}
    >
      <Flex
        alignItems="flex-start"
        gap={GAP_CLASS.GAP_200}
        className={styles.opportunityTooltip__header}
        data-testid="opportunity-tooltip-row-name"
      >
        <span
          aria-hidden="true"
          className={styles.opportunityTooltip__stageDot}
          data-testid="opportunity-tooltip-stage-dot"
          style={{ backgroundColor: stageColor }}
        />
        <span className={styles.opportunityTooltip__name}>
          {opportunityName}
        </span>
      </Flex>
      <Flex
        alignItems="baseline"
        justifyContent="space-between"
        gap={GAP_CLASS.GAP_300}
        data-testid="opportunity-tooltip-row-agency"
      >
        <span className={styles.opportunityTooltip__label}>Agency</span>
        <span className={styles.opportunityTooltip__value}>{customerName}</span>
      </Flex>
      {hasAssignees && (
        <Flex
          alignItems="baseline"
          justifyContent="space-between"
          gap={GAP_CLASS.GAP_300}
          data-testid="opportunity-tooltip-row-assignee"
        >
          <span className={styles.opportunityTooltip__label}>Assignee</span>
          <span className={styles.opportunityTooltip__value}>
            {assignees.join(", ")}
          </span>
        </Flex>
      )}
      <Flex
        alignItems="baseline"
        justifyContent="space-between"
        gap={GAP_CLASS.GAP_300}
        data-testid="opportunity-tooltip-row-time"
      >
        <span className={styles.opportunityTooltip__label}>Time in stage</span>
        <span className={styles.opportunityTooltip__value}>
          {daysLabel(daysInStage)}
        </span>
      </Flex>
      <Flex
        alignItems="baseline"
        justifyContent="space-between"
        gap={GAP_CLASS.GAP_300}
        data-testid="opportunity-tooltip-row-stage"
      >
        <span className={styles.opportunityTooltip__label}>Stage</span>
        <span className={styles.opportunityTooltip__value}>{stageName}</span>
      </Flex>
    </Flex>
  );
};

OpportunityTooltipContent.propTypes = {
  opportunity: shape({
    opportunityName: string.isRequired,
    customerName: string.isRequired,
    stageName: string.isRequired,
    stageColor: string.isRequired,
    daysInStage: number.isRequired,
    assignees: arrayOf(string).isRequired,
  }).isRequired,
};

export default OpportunityTooltipContent;
